import { useEffect, useState } from 'react';
import { IoDocuments } from 'react-icons/io5';
import { MdBarChart, MdDashboard, MdMonetizationOn } from 'react-icons/md';

import Widget from 'components/widget/Widget';
import UseApi from 'hooks/useApi';
import LineChart from './charts/lineChart';
import BarChart from './charts/barChart';
import PieChart from './charts/pieChart';
import AreaChart from './charts/areaChart';
import Card from 'components/card';

const Dashboard = () => {
  const [data, setData] = useState({
    usersCount: 0,
    packagesCount: 0,
    bookingsCount: 0,
    affiliatesCount: 0,
    referralsCount: 0,
    totalRevenue: 0,
  });
  const {
    usersCount,
    packagesCount,
    bookingsCount,
    affiliatesCount,
    referralsCount,
    totalRevenue,
  } = data;

  const { getApi } = UseApi();

  useEffect(() => {
    const fetchData = async () => {
      const [
        usersCount,
        packagesCount,
        bookingsCount,
        affiliatesCount,
        referralsCount,
        totalRevenue,
      ] = await Promise.all([
        getApi(`admin-actions/users-count`),
        getApi(`admin-actions/packages-count`),
        getApi(`admin-actions/bookings-count`),
        getApi(`admin-actions/affiliates-count`),
        getApi(`admin-actions/referrals-count`),
        getApi(`admin-actions/totalRevenue`),
      ]);

      setData({
        usersCount: usersCount?.data?.data,
        packagesCount: packagesCount?.data?.data,
        bookingsCount: bookingsCount?.data?.data,
        affiliatesCount: affiliatesCount?.data?.data,
        referralsCount: referralsCount?.data?.data,
        totalRevenue: totalRevenue?.data?.data,
      });
    };

    fetchData();
  }, []);
  return (
    <div>
      <div className="mt-3 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-3 ">
        <Widget
          icon={<MdBarChart className="h-7 w-7" />}
          title={'Active Users'}
          subtitle={usersCount}
        />
        <Widget
          icon={<IoDocuments className="h-6 w-6" />}
          title={'Total Packages'}
          subtitle={packagesCount}
        />
        <Widget
          icon={<MdBarChart className="h-7 w-7" />}
          title={'Total Bookings'}
          subtitle={bookingsCount}
        />
        <Widget
          icon={<MdDashboard className="h-6 w-6" />}
          title={'Affiliates'}
          subtitle={affiliatesCount}
        />
        <Widget
          icon={<MdBarChart className="h-7 w-7" />}
          title={'Referrals'}
          subtitle={referralsCount}
        />
        <Widget
          icon={<MdMonetizationOn className="h-6 w-6" />}
          title={'Total Revenue'}
          subtitle={'Rs ' + totalRevenue}
        />
      </div>
      <Card extra="grid grid-cols-1 gap-7  lg:grid-cols-2 p-8 my-10 overflow-hidden">
        <LineChart />
        <BarChart />
        <PieChart />
        <AreaChart />
      </Card>
    </div>
  );
};

export default Dashboard;
